import i18n from 'i18n-js';

export const AccountStatementStatuses = () => [
  { value: 'PAID', label: i18n.t('account_statement.statuses.PAID') },
  { value: 'PARTIAL', label: i18n.t('account_statement.statuses.PARTIAL') },
  { value: 'UNPAID', label: i18n.t('account_statement.statuses.UNPAID') },
  { value: 'VOID', label: i18n.t('account_statement.statuses.VOID') },
  { value: 'OVERPAID', label: i18n.t('account_statement.statuses.OVERPAID') },
];
